import { useLocalization } from "../../../features/localization/index.js";
import DataTableInput_default from "../../../components/data-table/DataTableInput.vue.js";
import { createBlock, createCommentVNode, createElementVNode, defineComponent, mergeModels, mergeProps, openBlock, renderSlot, unref, useId, useModel, useTemplateRef, withCtx } from "vue";
import { ScalarIconArrowCounterClockwise } from "@scalar/icons";
import { ScalarIconButton } from "@scalar/components/icon-button";
//#region src/v2/blocks/scalar-auth-selector-block/components/RequestAuthDataTableInput.vue?vue&type=script&setup=true&lang.ts
var RequestAuthDataTableInput_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "RequestAuthDataTableInput",
	props: /*@__PURE__*/ mergeModels({
		canReset: {
			type: Boolean,
			default: false
		},
		containerClass: {},
		environment: {},
		readOnly: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		type: {}
	}, {
		"modelValue": {
			default: "",
			required: true
		},
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([
		"reset",
		"inputFocus",
		"inputBlur",
		"selectVariable"
	], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const id = useId();
		const { translate } = useLocalization();
		/**
		* The unmasked editor is a contenteditable div, which a <label for> cannot
		* name, so the field points back at the visible label via aria-labelledby.
		* The masked native input is named the same way.
		*/
		const labelId = `${id}-label`;
		const field = useTemplateRef("field");
		/**
		* Reset hides itself once the value matches the default again, so focus moves to the field
		* first instead of falling back to the page.
		*/
		const handleReset = () => {
			field.value?.focus();
			emit("reset");
		};
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DataTableInput_default), mergeProps({
				id: unref(id),
				ref_key: "field",
				ref: field
			}, _ctx.$attrs, {
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				"aria-labelledby": labelId,
				canAddCustomEnumValue: !__props.readOnly,
				containerClass: __props.containerClass,
				environment: __props.environment,
				readOnly: __props.readOnly,
				required: __props.required,
				type: __props.type,
				onInputBlur: _cache[1] || (_cache[1] = ($event) => emit("inputBlur")),
				onInputFocus: _cache[2] || (_cache[2] = ($event) => emit("inputFocus")),
				onSelectVariable: _cache[3] || (_cache[3] = ($event) => emit("selectVariable", $event))
			}), {
				default: withCtx(() => [createElementVNode("label", { id: labelId }, [renderSlot(_ctx.$slots, "default")])]),
				icon: withCtx(() => [renderSlot(_ctx.$slots, "icon"), __props.canReset && !__props.readOnly ? (openBlock(), createBlock(unref(ScalarIconButton), {
					key: 0,
					class: "h-6 w-6 self-center p-1.25",
					icon: unref(ScalarIconArrowCounterClockwise),
					label: unref(translate)("apiClient.dataTableInput.resetValue"),
					onClick: handleReset
				}, null, 8, ["icon", "label"])) : createCommentVNode("", true)]),
				_: 3
			}, 16, [
				"id",
				"modelValue",
				"canAddCustomEnumValue",
				"containerClass",
				"environment",
				"readOnly",
				"required",
				"type"
			]);
		};
	}
});
//#endregion
export { RequestAuthDataTableInput_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=RequestAuthDataTableInput.vue_vue_type_script_setup_true_lang.js.map